import client from './client'
import store from '@/store'

let videosService = {}

videosService.getVideoContactLink = async function() {
  try {
    const res = await client.get('/videos/contact-link/')
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getVideosList = async function(slug = '', payload = '') {
  try {
    let path
    if (slug) {
      path = `/videos/${slug}/`
    } else {
      path = 'videos'
    }
    const res = await client.get(path, payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getDemosList = async function(slug = '', payload = '') {
  try {
    let path
    if (slug) {
      path = `/demos/${slug}/`
    } else {
      path = 'demos'
    }
    const res = await client.get(path, payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getFeaturedVideos = async function() {
  try {
    const res = await client.get('/videos/featured/')
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getVideosUserHistory = async function() {
  try {
    const res = await client.get('/videos/user-history/')
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getVideosUserHistory = async function() {
  try {
    const res = await client.get('/videos/user-history/')
    return res.data
  } catch (error) {
    return error
  }
}

videosService.getVideosFilters = async function(slug) {
  try {
    const res = await client.get(`/filters/${slug}/`)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.getVideo = async function(slug) {
  try {
    const res = await client.get(`/videos/video/${slug}/`)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.createInteraction = async function(payload) {
  try {
    const res = await client.post('/viewings/interaction/', payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

videosService.createViewing = async function(payload) {
  try {
    const res = await client.post('/viewings/viewing/', payload)
    return res.data
  } catch (error) {
    if (error.response.status === 429) {
      store.commit('setError429', true)
    }
    return error
  }
}

export default videosService
